import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { Font } from '../../constants'
import { Routing } from '../../modules/routing'
Locale.getInstance().registerKeySet('fr', 'profileNotification', {
  description:
    'Les notifications sont envoyées par courriel.<br> Vous pouvez vous désabonner à tout moment.',
  newsletter: 'Infolettre',
  newsletterDescription: "Recevoir l'infolettre de La Vitrine pour ne rien manquer.",
  favorites: 'Favoris',
  favoritesDescription: 'Recevoir des nouvelles concernant vos artistes et lieux favoris.',
  upcomingEventsDescription: 'Recevoir des rappels concernant vos prochains événements.',
  save: 'Sauvegarder',
  changeSavedMsg: 'Vos modifications ont été sauvegardées',
})

Locale.getInstance().registerKeySet('en', 'profileNotification', {
  description: 'Notifications are sent via email.<br> You may unsubscribe at any time.',
  newsletter: 'Newsletter',
  newsletterDescription: "I want to subscribe to La Vitrine's newsletter.",
  favorites: 'Favorites',
  favoritesDescription:
    'I wish to receive notifications linked to my favorites artists and venues.',
  upcomingEventsDescription: 'Alerts for upcoming events.',
  save: 'Save my preferences',
  changeSavedMsg: 'Your changes have been saved',
})

export interface LvcProfileNotificationModalContent {
  newsletter: boolean
  favorites: boolean
  upcomingEvents: boolean
}

export class LvcProfileNotificationModalContent extends MinzeElement {
  reactive: Reactive = [
    ['newsletter', false],
    ['favorites', false],
    ['upcomingEvents', false],
  ]

  async onReady(): Promise<void> {
    const mainModule = MainModule.getInstance()
    mainModule.getEE().on('lvc:user_state_changed', this.handleAuthChange.bind(this))
    this.handleAuthChange()
  }

  handleAuthChange() {
    const mainModule = MainModule.getInstance()
    const userData = mainModule.getAuth().getUserData()

    if (userData && userData.profile) {
      const notifications = userData.profile.notifications

      this.newsletter = notifications && notifications.newsletter
      this.favorites = notifications && notifications.favorites
      this.upcomingEvents = notifications && notifications.upcomingEvents

      this.rerender()
    }
  }

  goBack() {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()

    routing.goToLastPage()
  }

  save = () => {
    const mainModule = MainModule.getInstance()

    const newsletterElement = this.select('#newsletter')
    const newsletter = newsletterElement?.getAttribute('active') === 'true'

    const favoritesElement = this.select('#favorites')
    const favorites = favoritesElement?.getAttribute('active') === 'true'

    const comingElement = this.select('#coming')
    const upcomingEvents = comingElement?.getAttribute('active') === 'true'

    mainModule.getAuth().saveProfile('profile-notification', {
      newsletter,
      favorites,
      upcomingEvents,
    })
    mainModule.showToastAlert(Locale.getKey('profileNotification.changeSavedMsg'))
  }

  html = () => `
    <div class="form">
      <lvc-box mt="8px">
        <lvc-text font-preset="medium">${Locale.getKey('profileNotification.description')}<lvc-text>
      </lvc-box>
      <lvc-box
        mt="32px"
        padding="${window.matchMedia('(max-width: 730px)').matches ? '16px 0' : '24px 0px'}"
        borderTop="1px solid #1E007D"
        borderBottom="1px solid #1E007D"
      >
        <lvc-box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <lvc-box
            display="flex"
            flexDirection="column"
            rowGap="${window.matchMedia('(max-width: 730px)').matches ? '8px' : '0'}"
          >
            <lvc-text font-preset="largeExtraBold">${Locale.getKey('profileNotification.newsletter')}</lvc-text>
            <lvc-text font-preset="medium">${Locale.getKey('profileNotification.newsletterDescription')}</lvc-text>
          </lvc-box>
          <lvc-box ml="8px">
            <lvc-switch default-active="${
              this.newsletter ? 'true' : ''
            }" id="newsletter"></lvc-switch>
          </lvc-box>
        </lvc-box>
      </lvc-box>

      <lvc-box
        padding="${window.matchMedia('(max-width: 730px)').matches ? '16px 0' : '24px 0px'}"

      >
        <lvc-box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <lvc-box
            display="flex"
            flexDirection="column"
            rowGap="${window.matchMedia('(max-width: 730px)').matches ? '8px' : '0'}"
          >
            <lvc-text font-preset="largeExtraBold">${Locale.getKey('profileNotification.favorites')}</lvc-text>
            <lvc-text>${Locale.getKey('profileNotification.favoritesDescription')}</lvc-text>
          </lvc-box>
          <lvc-box ml="8px">
            <lvc-switch default-active="${
              this.favorites ? 'true' : ''
            }" id="favorites"></lvc-switch>
          </lvc-box>
        </lvc-box>
      </lvc-box>

      <lvc-box
        padding="${window.matchMedia('(max-width: 730px)').matches ? '8px 0px 16px 0px' : '0px 0px 24px 0px'}"
        borderBottom="1px solid #1E007D"
      >
        <lvc-box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <lvc-box
            display="flex"
            flexDirection="column"
            rowGap="${window.matchMedia('(max-width: 730px)').matches ? '8px' : '0'}"
          >
            <lvc-text>${Locale.getKey('profileNotification.upcomingEventsDescription')}</lvc-text>
          </lvc-box>
          <lvc-box ml="8px">
            <lvc-switch default-active="${
              this.upcomingEvents ? 'true' : ''
            }" id="coming"></lvc-switch>
          </lvc-box>
        </lvc-box>
      </lvc-box>

      <lvc-box width="100%" mt="32px" class="button-wrapper">
        <lvc-button enable-hover-box-shadow="true" theme="dark" width="100%" id="btn-save" border-radius="99px">
            ${Locale.getKey('profileNotification.save')}
        </lvc-button>
      <lvc-box>
    </div>
  `

  css = () => `
    :host {

    }
    @media screen and (max-width: 991px) {
      .button-wrapper {
        position: fixed;
        bottom: 73px;
        left: 0;
        right: 0;
        padding: 18px 16px;
        width: 100%;
        height: fit-content;
        max-width: calc(540px + 16*2px);
        margin: auto;
      }
    }
  `

  eventListeners: EventListeners = [['#btn-save', 'click', this.save]]
}
